import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { WORKFLOW_TRIGGERS } from 'modules/workflows/constants';
import { getIsJourneyStartTimeOptimizationEnabled } from 'modules/workflows/ducks';
import { useStartNodeContext } from '../../StartNodeEditor.context';
import { getFormattedSchedulerFormValues } from '../../ScheduleEntrySource/Scheduler/Scheduler.utils';
import { SchedulerFormStateValues } from '../../ScheduleEntrySource/Scheduler/Scheduler.types';

/**
 * Used to grab formatted scheduler data to combine with node data
 * @returns {object} formatted SchedulerFormStateValues or empty object for sending to the backend
 */
export const useGetSchedulerFormData = () => {
  const { getValues } = useFormContext();
  const { nodeData } = useStartNodeContext();
  const { nodeClass } = nodeData;
  const isStartTimeOptEnabled = useSelector(getIsJourneyStartTimeOptimizationEnabled);

  return useCallback(
    () =>
      nodeClass === WORKFLOW_TRIGGERS.SCHEDULED_RECURRING_LIST
        ? getFormattedSchedulerFormValues(
            getValues() as SchedulerFormStateValues,
            isStartTimeOptEnabled,
          )
        : {},
    [getValues, nodeClass],
  );
};
